import { createFileRoute, redirect } from '@tanstack/react-router'

// The defaults page became the `defaults` source of the sync page (spec
// 2026-09-25-02). Kept so bookmarks and old links still land somewhere.
export const Route = createFileRoute('/$org/types/defaults')({
  beforeLoad: ({ params }) => {
    throw redirect({
      to: '/$org/types/sync',
      params: { org: params.org },
      search: { source: 'defaults' },
    })
  },
})
